import { ImageAlbumIcon } from './ImageAlbumIcon';

/**
 * author: Google
 * id DD2262AA-A145-4788-899D-46D807B4FC0D
 * name image-album
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-album.svg
 * tags
 */
export const PhotoAlbumIcon = ImageAlbumIcon;
export default PhotoAlbumIcon